// [href, label] — same shape as the badges in experience_data.js.
export const skills_data = {
  Languages: [
    ['https://go.dev/', 'Go'],
    ['https://www.python.org/about/', 'Python'],
    ['https://learn.microsoft.com/en-us/dotnet/csharp/', 'C#'],
    ['https://developer.mozilla.org/en-US/docs/Web/JavaScript', 'JavaScript'],
  ],
  'Infrastructure & Platform': [
    ['https://kubernetes.io/', 'Kubernetes'],
    ['https://www.terraform.io/', 'Terraform'],
    ['https://helm.sh/', 'Helm'],
    ['https://argo-cd.readthedocs.io/', 'ArgoCD'],
    ['https://www.docker.com/', 'Docker'],
    ['https://flyte.org/', 'Flyte'],
    ['https://www.datadoghq.com/', 'Datadog'],
  ],
  'Cloud & Backend': [
    ['https://aws.amazon.com/', 'AWS'],
    ['https://azure.microsoft.com/', 'Azure'],
    ['https://grpc.io/', 'gRPC'],
    ['https://protobuf.dev/', 'Protobuf'],
    [
      'https://dotnet.microsoft.com/en-us/learn/dotnet/what-is-dotnet',
      '.NET',
    ],
    ['https://en.wikipedia.org/wiki/SQL', 'SQL'],
  ],
};
